import React, { ReactNode } from 'react';

import Button from 'components/core/Button';
import Modal from 'components/core/Modal';
import Text from 'components/core/Text';

type TAlertModalProps = {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  closeLabel?: string;
  onClose: () => void;
};

const AlertModal = ({ isOpen, title, message, closeLabel = 'OK', onClose }: TAlertModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    width={440}
    footer={
      <Button variant="primary" onClick={onClose}>
        {closeLabel}
      </Button>
    }>
    {typeof message === 'string' ? (
      <Text variant="body" color="textSecondary">
        {message}
      </Text>
    ) : (
      message
    )}
  </Modal>
);

export default AlertModal;
